"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionFooter = void 0;
var _mui = require("@ori-ui/mui");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2, 0, 4, 0),
  textAlign: 'center',
  textDecoration: 'underline',
  [theme.breakpoints.up('sm')]: {
    borderRadius: theme.spacing(0, 0, 2, 2)
  }
}));
const SubscriptionFooter = () => {
  const {
    manageSubscriptionLink
  } = (0, _contexts.useCheckoutBasket)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      href: manageSubscriptionLink,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "button",
        children: formatMessage('manageSubscriptions')
      })
    })
  });
};
exports.SubscriptionFooter = SubscriptionFooter;